var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg034Female(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 2C8.89423 2.01799 6.31558 4.40302 6.05573 7.49789C5.79587 10.5928 7.94072 13.3744 10.9999 13.91V16H8.99994C8.44765 16 7.99994 16.4477 7.99994 17C7.99994 17.5523 8.44765 18 8.99994 18H10.9999V21C10.9999 21.5523 11.4477 22 11.9999 22C12.5522 22 12.9999 21.5523 12.9999 21V18H14.9999C15.5522 18 15.9999 17.5523 15.9999 17C15.9999 16.4477 15.5522 16 14.9999 16H12.9999V13.91C16.0592 13.3744 18.204 10.5928 17.9441 7.49789C17.6843 4.40302 15.1056 2.01799 11.9999 2ZM11.9999 12C9.7908 12 7.99994 10.2091 7.99994 8C7.99994 5.79086 9.7908 4 11.9999 4C14.2091 4 15.9999 5.79086 15.9999 8C15.9999 9.06087 15.5785 10.0783 14.8284 10.8284C14.0782 11.5786 13.0608 12 11.9999 12Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg034Female);
export default __webpack_public_path__ + "static/media/034-female.f82ca73e3ee3fdab3ae4f812cae3b66e.svg";
export { ForwardRef as ReactComponent };